import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCurrentBreakpoint } from '@travel-frontend/core';
import { Content } from '../../../../primitives/Grid/Grid/components/Content.js';
export const Conditional = props => {
  const breakpoint = useCurrentBreakpoint();
  return _jsx(Content, {
    ...props,
    currentBreakpoint: breakpoint
  });
};